import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const SolarPanel: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m656.95 540h-534.01l54.11-420h359.47c39.11 0 72.28 28.58 77.15 66.48l43.28 353.51zm-499.89-30h466l-39.15-319.78c-2.94-22.89-23.31-40.22-47.38-40.22h-333.1l-46.38 360z' />
    <path d='m294.96 527.89c-.34 0-.69-.01-1.04-.04-8.27-.56-14.51-7.72-13.95-15.99l24.92-365.7c.56-8.26 7.7-14.51 15.98-13.95 8.27.56 14.51 7.72 13.95 15.99l-24.92 365.7c-.54 7.92-7.13 13.98-14.95 13.98z' />
    <path d='m485.88 527.89c-7.87 0-14.47-6.13-14.96-14.09l-22.3-365.7c-.5-8.27 5.79-15.38 14.06-15.89 8.28-.51 15.38 5.79 15.89 14.06l22.3 365.7c.5 8.27-5.79 15.38-14.06 15.89-.31.02-.62.03-.93.03z' />
    <path d='m180 254.08h420v30h-420z' />
    <path d='m615.27 410h-448.51c-8.28 0-15-6.72-15-15s6.72-15 15-15h448.51c8.28 0 15 6.72 15 15s-6.72 15-15 15z' />
    <path d='m210 660v-89.7h30v59.7c0 16.57-13.43 30-30 30z' />
    <path d='m540 660v-90.03h30v60.03c0 16.57-13.43 30-30 30z' />
  </IconBase>
));

SolarPanel.displayName = 'SolarPanel';

export default SolarPanel;
